import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error (known Radix UI issue, non-critical)
// This error is benign and doesn't affect functionality
const suppressResizeObserverError = () => {
  const errorHandler = (e) => {
    if (e.message && e.message.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  };
  
  window.addEventListener('error', errorHandler);
  
  // Also override console.error to suppress these messages
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
};

suppressResizeObserverError();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
